import { Navigate, Outlet } from 'react-router-dom';

/**
 * AdminGuard Component
 * 
 * Restricts access to the Admin Dashboard.
 * Only users with SUPER_ADMIN role can enter.
 */
function AdminGuard() {
    const userStr = localStorage.getItem('user');
    const token = localStorage.getItem('token');

    if (!token || !userStr) {
        return <Navigate to="/login" replace />;
    }

    try {
        const user = JSON.parse(userStr);
        if (user.role !== 'SUPER_ADMIN') {
            return <Navigate to="/app" replace />;
        }
    } catch (e) {
        return <Navigate to="/login" replace />;
    }

    return <Outlet />;
}

export default AdminGuard;
